import React from 'react';
import { trackCTAClick } from '../analytics';
import './Button.css';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
  className?: string;
  href?: string;
  target?: string;
  trackingLabel?: string;
  trackingLocation?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  onClick,
  className = '',
  href,
  target,
  trackingLabel,
  trackingLocation,
}) => {
  const handleClick = () => {
    if (trackingLabel) {
      trackCTAClick(trackingLabel, trackingLocation || 'unknown');
    }
    onClick?.();
  };

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noreferrer' : undefined}
        className={`btn btn-${variant} ${className}`}
        style={{ textDecoration: 'none', display: 'inline-block' }}
        onClick={handleClick}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={`btn btn-${variant} ${className}`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default Button;